import { ReactNode } from 'react';
import styles from './MeasurementSection.module.css';

interface MeasurementSectionProps {
  title: string;
  children: ReactNode;
}

export default function MeasurementSection({
  title,
  children,
}: MeasurementSectionProps) {
  return (
    <div className={styles.section}>
      {title && (
        <div className={styles.header}>
          <div className={styles.accentBar} />
          <span
            className={styles.title}
            data-testid="measurement-section-title"
          >
            {title}
          </span>
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
}
